import api from './apiService';

const physicalInventoryService = {
    async getInventories(params = {}) {
        try {
            const response = await api.get('/physical-inventories', { params });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des inventaires:', error);
            throw error;
        }
    },

    async getInventoryById(id) {
        try {
            const response = await api.get(`/physical-inventories/${id}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération de l\'inventaire:', error);
            throw error;
        }
    },

    async createInventory(data) {
        try {
            const response = await api.post('/physical-inventories', data);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la création de l\'inventaire:', error);
            throw error;
        }
    },

    async deleteInventory(id) {
        try {
            const response = await api.delete(`/physical-inventories/${id}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la suppression de l\'inventaire:', error);
            throw error;
        }
    },

    async addProducts(inventoryId, productIds) {
        try {
            const response = await api.post(`/physical-inventories/${inventoryId}/products`, {
                product_ids: productIds
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'ajout des produits:', error);
            throw error;
        }
    },

    async removeProduct(inventoryId, itemId) {
        try {
            const response = await api.delete(`/physical-inventories/${inventoryId}/items/${itemId}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors du retrait du produit:', error);
            throw error;
        }
    },

    async startInventory(inventoryId) {
        try {
            const response = await api.post(`/physical-inventories/${inventoryId}/start`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors du démarrage de l\'inventaire:', error);
            throw error;
        }
    },

    async recordItemCount(inventoryId, itemId, data) {
        try {
            const response = await api.post(`/physical-inventories/${inventoryId}/items/${itemId}/count`, data);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'enregistrement du comptage:', error);
            throw error;
        }
    },

    async completeInventory(inventoryId) {
        try {
            const response = await api.post(`/physical-inventories/${inventoryId}/complete`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la finalisation de l\'inventaire:', error);
            throw error;
        }
    },

    async approveInventory(inventoryId) {
        try {
            const response = await api.post(`/physical-inventories/${inventoryId}/approve`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'approbation de l\'inventaire:', error);
            throw error;
        }
    },

    async rejectInventory(inventoryId, notes = null) {
        try {
            const response = await api.post(`/physical-inventories/${inventoryId}/reject`, {
                notes
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors du rejet de l\'inventaire:', error);
            throw error;
        }
    },

    async getStatistics() {
        try {
            const response = await api.get('/physical-inventories/statistics');
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des statistiques:', error);
            throw error;
        }
    },

    async bulkApplyInventoryAdjustments(inventoryId, itemIds) {
        try {
            const response = await api.post(`/physical-inventories/${inventoryId}/bulk-apply`, {
                item_ids: itemIds
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'application groupée des ajustements:', error);
            throw error;
        }
    },

    async bulkRecount(inventoryId, itemIds) {
        try {
            const response = await api.post(`/physical-inventories/${inventoryId}/bulk-recount`, {
                item_ids: itemIds
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors du recomptage groupé:', error);
            throw error;
        }
    },

    getStatusLabel(status) {
        const labels = {
            draft: 'Brouillon',
            in_progress: 'En cours',
            completed: 'Terminé',
            approved: 'Approuvé',
            rejected: 'Rejeté'
        };
        return labels[status] || status;
    },

    getStatusColor(status) {
        const colors = {
            draft: 'gray',
            in_progress: 'blue',
            completed: 'orange',
            approved: 'green',
            rejected: 'red'
        };
        return colors[status] || 'gray';
    }
};

export default physicalInventoryService;

